import { createStoreChunk } from '@core/store'

import { type TCheckoutRequest } from '../types/checkoutTypes'

type TCheckoutState = { request: TCheckoutRequest | null; isRedirectPending: boolean }

export const checkoutStore = createStoreChunk<TCheckoutState>('checkout')({
    initialState: { request: null, isRedirectPending: false },
})
